// To build the file

export const base_path ='/' 

// To run the file in localhose
// export const base_path ='/'
 
export const img_path = '/'
